export default "__VITE_ASSET__b12ae346__"